import React, { useEffect } from "react"
import { findField } from "@app/utils/form"
import { useFormikContext } from "formik"
import { useRouteLoaderData } from "react-router-dom"

export const useTypicalRisks = (values) => {
	const { jobs } = useRouteLoaderData("root") || {}
	const jobId = values["taetigkeit_beschreibung_ueberlassungals__ID"]
	const job = jobs.find(({ Berufschluessel }) => Berufschluessel === jobId)
	const risks = job?.Typische_Gefaehrdung?.split(";").map(entry => entry.trim())
	return { jobId, risks}
}

export const useTypicalRisksObserver = (currentFieldsets) => {
	const typicalRisksField = findField(currentFieldsets, "physischegefaehrdungsanalyse_gefaehrdungen_typische-gefaehrdungen")
	const { values } = useFormikContext()
	const { jobId, risks } = useTypicalRisks(values);

	let res = React.useMemo(() => {
		if (typicalRisksField) {
			typicalRisksField.elementType = "typicalRisksHint"
		}
		if (typicalRisksField && risks) {
			typicalRisksField.riskItems = risks
		}

		return {
			fieldsets: currentFieldsets,
		}
	}, [typicalRisksField, jobId])


	const clickNextField = findField(res.fieldsets, "physischegefaehrdungsanalyse_gefaehrdungen_weiter-klicken")
	res = React.useMemo(() => {
		if (clickNextField) {
			clickNextField.simple = true
		}

		return {
			fieldsets: currentFieldsets,
		}
	}, [clickNextField, currentFieldsets])

	return res
}

